import React from "react";
import { FeatureDetail } from "./FeatureDetail";
import type { MapFeatureProperties } from "../../api/map";

interface FeatureDetailOverlayProps {
  feature: MapFeatureProperties;
  onClose: () => void;
  onShowOnMap: (f: MapFeatureProperties) => void;
}

export function FeatureDetailOverlay({ feature, onClose, onShowOnMap }: FeatureDetailOverlayProps) {
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 60, display: "flex", justifyContent: "flex-end" }}>
      <div
        onClick={onClose}
        style={{ position: "absolute", inset: 0, background: "rgba(10,14,18,.6)" }}
      />
      <div
        style={{
          position: "relative",
          width: 380,
          maxWidth: "92vw",
          height: "100%",
          background: "var(--surface-card)",
          borderLeft: "1px solid var(--border-subtle)",
          boxShadow: "var(--shadow-md)",
        }}
      >
        <FeatureDetail
          feature={feature}
          nearby={[]}
          onBack={onClose}
          onSelect={() => {}}
          onShowOnMap={onShowOnMap}
        />
      </div>
    </div>
  );
}
